<template>
  <div class="modal offer-modal skin-modal">
    <div class="overlay" @click="$emit('closeSaleSkinModal')"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$emit('closeSaleSkinModal')"
        src="./../img/cross.svg"
      />
      <div class="container">
        <form @submit.prevent="create">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>Sell Your Skin</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="input-container">
                  <div class="desc">Skin name:</div>
                  <input type="text" placeholder="Skin name" v-model="title" />
                </div>
                <div class="input-container">
                  <div class="desc">Desired price:</div>
                  <input
                    type="text"
                    placeholder="Desired price"
                    v-model="price"
                    @input="allowOnlyNumbers"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Quality:</div>
                  <select v-model="quality">
                    <option
                      v-for="(item, i) in qualityOptions"
                      :value="item"
                      :key="i"
                    >
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <div class="desc">Steam inventory link to skin:</div>
                  <input
                    type="text"
                    placeholder="Steam inventory link to skin"
                    v-model="item_url"
                  />
                </div>
                <div class="buttons">
                  <button
                    class="button orange-btn"
                    @click="$emit('closeSaleSkinModal')"
                  >
                    <span>Cancel</span>
                  </button>
                  <button class="button" type="submit">
                    <span>Send</span>
                  </button>
                </div>
                <transition name="fade">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SaleSkinModal",
  props: [],
  components: {},
  data: function () {
    return {
      title: "",
      price: "",
      quality: "",
      item_url: "",
      qualityOptions: [
        "Well-Worn",
        "Field-Tested",
        "Minimal Wear",
        "Factory New",
      ],
    };
  },
  methods: {
    allowOnlyNumbers() {
      this.price = this.price.replace(/[^0-9.,]/g, "");

      // Split the input into integer and decimal parts
      const parts = this.price.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];

      // Limit decimal part to two digits
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }

      // Concatenate the integer and decimal parts back
      this.price =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    closeSaleSkinModal() {
      this.$emit("closeSaleSkinModal");
    },
    create() {
      let data = {
        title: this.title,
        price: this.price,
        quality: this.quality,
        item_url: this.item_url,
        currency: this.$parent.currency,
      };
      this.$emit("createOffer", data);
    },
  },
};
</script>
